export default "__VITE_ASSET__DnXSfuQF__"